import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { SEOHead } from "@/components/SEOHead";
import LogoSlider from "@/components/LogoSlider";
import About from "@/components/About";
import PracticeAreas from "@/components/PracticeAreas";
import Team from "@/components/Team";
import Testimonials from "@/components/Testimonials";
import Possibilities from "@/components/Possibilities";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  const schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "LegalService",
    name: "Pinheiro Advocacia",
    image:
      "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a30a307d64da5ce6b7c3c23.webp",
    url: "https://advpinheiro.com.br",
    description:
      "Atuação exclusivamente à proteção dos salários e das aposentadoria dos servidores públicos. Mais de 3.000 clientes já obtiveram a nossa ajuda jurídica.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Rua Antonio Ferreira, 24",
      addressLocality: "Campolim, Sorocaba",
      addressRegion: "SP",
      postalCode: "18047-636",
      addressCountry: "BR",
    },
    telephone: "+5515991444985",
    priceRange: "$$",
    openingHours: "Mo,Tu,We,Th,Fr 09:00-18:00",
    sameAs: [
      "https://www.instagram.com/pinheiro.advocacia/",
      "https://www.facebook.com/pinheiroadvocaciaparaoservidor",
      "https://www.youtube.com/@pinheiroadvocaciaservidorp5141",
    ],
  });

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Página Inicial"
        description="Atuação exclusivamente à proteção dos salários e das aposentadoria dos servidores públicos. Mais de 3.000 clientes já obtiveram a nossa ajuda jurídica."
        canonical="/"
        schemaJson={schemaJson}
      />
      <Header />
      <main>
        <Hero />
        <LogoSlider />
        <About />
        <PracticeAreas />
        <Possibilities />
        <Testimonials />
        <Team />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
